module.exports = function getResource(label) {
    let resources = {
        orderSummary: 'Sommaire de la commande'
    };

    return resources[label];
};
